import axios from "axios";
import React, { useEffect, useState } from "react";
import validator from "validator";
import DashboardLayouts from "../../Components/Layout/DashboardLayouts";

import "react-datepicker/dist/react-datepicker.css";
import { BsArrowLeft } from "react-icons/bs";
import { Link } from "react-router-dom";



import Loader from "../../Components/Global/Loader";
import { useAuth } from "../../Context/AuthContext";
import Paginations from "../../hooks/Paginations";
import useAuthentication from "../../hooks/useAuthentication";
import useSearchListPagination from "../../hooks/useSearchListPagination";
import AddBankModal from "./modal/AddBankModal";
import DeleteModal from "./modal/DeleteModal";
import TablesList from "./TablesList";

function BankInformations({ allowedRoles }) {
    const { allowLoading } = useAuthentication(allowedRoles);

    const [isSubmit, setIsSubmit] = useState(false);
 
    const handleClose = () => {
        setBankInfos({})
        setModals({
            ...Object.keys(modals).reduce((reduced, key) => ({ ...reduced, [key]: false }), {})
        })
        
    };
  

    const [errorMessage, setErrorMessage] = useState("");

    const [modals, setModals] = useState({
        addModal: false,
         deleteModal: false,

    })

    const [bankinfos, setBankInfos] = useState(
        {
            bank_name: "",

            account_number: [""],
        },
    );

    const validationFunc = () => {
        let errors = ""
        setErrorMessage("")
        bankinfos?.account_number?.map((an, i) => {
            if (!validator.isNumeric(an)) {
                setErrorMessage("Please valid ")

                errors = { ...errors, [i]: `${i} errors ` }
            }
        }
        )
        return errors;
    }
    const SubmitHandler = async (e) => {

        setIsSubmit(true)
        const validd = validationFunc()

        if (Object.keys(validd)?.length == 0) {
            setLoadingPagination(true);


            const set_url = bankinfos?.deleteBank ? `/bankdetails/delete/${bankinfos?.id}` : bankinfos?.createdAt ? `/bankdetails/update/${bankinfos?.id}` : "/bankdetails/create";

                await axios
                    .post(set_url, bankinfos)
                    .then(function (response) {
                        if (response.status == 200) {
                            // getbanks();
                            setLoadingPagination(false);
                            handleClose()
                            SearchListApi(`bankdetails`, source);
                            setBankInfos({
                                bank_name: "",

                                account_number: [""],
                            })
                            setIsSubmit(false)
                            setErrorMessage("")
                        } else if (response.status == 201) {

                            setErrorMessage({ db: response?.data?.errMsg })

                        }
                    })
                    .catch(function (error) {
                        setLoadingPagination(false);
                        handleClose()
                        setIsSubmit(false)
                        setErrorMessage("")

                    });
            

        }

        // }
    };

    const { designation } = useAuth();




    const {
        setisKeyPress,
        Count,
        setsearchKey,
        searchKey,
        setRecord,
        record,
        setPages,
        pages,
        totallength,
        paginationLoading,
        handleNextbtn,
        handlePrevbtn,
        PageShowFunc,
        SearchListApi,
        allData,
        PagesFunc,
        responseData,
        setLoadingPagination
    } = useSearchListPagination();


    const source = axios.CancelToken.source();
    useEffect(() => {

        if (searchKey) {
            SearchListApi(`bankdetails`, source);
        } else {
            SearchListApi(`bankdetails`, source);
        }

        return () => source.cancel();
    }, [searchKey, record, pages]);





    const tableHeaderFieldsName = [
        "Sl No.", "Bank Name", "Account Numbers", "Action"
    ]
    const tableValueData = {
        value: [
            "bank_name", "account_number_all"
        ], design: {}
    }

    const [tableBodyValue, settableBodyValue] = useState([])


    useEffect(() => {

        settableBodyValue(allData?.map(data => ({ ...data, account_number_all: data?.account_number })))

    }, [allData])

    const editTaxData = (item) => {
        setBankInfos(item)
        setModals({
            ...Object.keys(modals).reduce((reduced, key) => ({ ...reduced, [key]: false }), {}), addModal: true
        })
     
    }



    const deleteSingleTax = async (item) => {
        setBankInfos({ ...item, deleteBank: item?.bank_name })
   
    }
    const deleteBankFunc = async () => {
        await axios.delete(`/bankdetails/delete/${bankinfos?.id}`, bankinfos)
        SearchListApi(`bankdetails`, source);
        setBankInfos({
            bank_name: "",
            account_number: [""],
            deleteBank: ""
        })
    }



    return (
        <>
            <DashboardLayouts>
                {(paginationLoading || allowLoading) && <Loader />}

            
                <div className="breadcrumb row justify-content-between align-items-center">
                    <div className="d-flex align-items-center dashboard-upper-menu col-md-6 col-auto">
                        <Link
                            to={
                                designation === "Owner" || designation === "Partner"
                                    ? "/dashboard"
                                    : `/${designation}dashboard`.toLowerCase()
                            }
                            className="d-flex align-items-center"
                        >
                            <BsArrowLeft className="me-2 m-0 back-arrow" color="black" />
                            <i className="icon-dashboard"></i>
                            <h3 className="mb-0 fw-normal">Dashboard</h3>
                        </Link>
                    </div>

                    <div className="col-auto btn-responsive">
                        <button className="btn btn-outline-primary" onClick={() => {
                            setBankInfos({
                                bank_name: "",

                                account_number: [""],
                            })
                            setModals({
                                ...Object.keys(modals).reduce((reduced, key) => ({ ...reduced, [key]: false }), {}), addModal: true
                            })

                        }
                        }>
                            Add Bank
                        </button>
                    </div>
                </div>


                <TablesList
                    tableNameData={tableHeaderFieldsName}

                    designation={designation} tableValueData={tableValueData} datasShow={tableBodyValue}
                    setPages={setPages} pages={pages} record={record} setRecord={setRecord} setsearchKey={setsearchKey} setisKeyPress={setisKeyPress} searchKey={searchKey} SearchListApi={SearchListApi}
                    showTitle={true}

                    title={'Bank'} isSearchField={true} isDeleteIconShow={true} isEditIconShow={true} onClickDeleteFunc={deleteSingleTax} onClickEditFunc={editTaxData} />


                {Count > 5 && totallength.length > 1 &&
                    <Paginations onPageChange={PagesFunc} currentPage={pages} totalPages={totallength.length} />
                }





                <DeleteModal show={bankinfos?.deleteBank} handleClose={handleClose} modalData={bankinfos?.deleteBank} handleSubmit={deleteBankFunc} />
                <AddBankModal show={modals.addModal} setBankInfos={setBankInfos} handleClose={handleClose} handleSubmit={SubmitHandler} errorMessage={errorMessage} workerData={bankinfos} setIsSubmit={setIsSubmit} bankinfos={bankinfos} isSubmit={isSubmit} />


            </DashboardLayouts>
        </>
    );
}
export default BankInformations;
